import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromMinutesToMilliseconds, fromSecondsToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SmartIdAuthTransactionConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getVerificationStatusEndpoint(): string {
		return this.service.get(
			(x) => x.core.smartIdAuthTransaction.endpoints?.verification,
			"v2/authentication-transaction/status"
		);
	}

	getVerificationEndpoint(): string {
		return this.service.get(
			(x) => x.core.smartIdAuthTransaction.endpoints?.verificationStatus,
			"v2/authentication-transaction"
		);
	}

	getVerificationStatusInterval(): number {
		return this.service.get(
			(x) => x.core.authTransaction.verificationStatusInterval,
			fromSecondsToMilliseconds(1.5)
		);
	}

	getVerificationStatusTimeout(): number {
		return this.service.get((x) => x.core.authTransaction.verificationStatusTimeout, fromMinutesToMilliseconds(3));
	}
}
